/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lifestyle-item[_ngcontent-%COMP%]{height:auto}@media only screen and (min-width:600px){.lifestyle-item[_ngcontent-%COMP%]{width:200px}}.lifestyle-item[_ngcontent-%COMP%]   h3.title[_ngcontent-%COMP%]{margin-bottom:0}.lifestyle-item[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{background:#fff;border-radius:100%}.main-image[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/downtown-life/finishes.component.scss.shim.ngstyle.js.pre-build-optimizer.js